<ng-container *ngIf="block">
    <div class="input-group mb-3">
        <input type="search" class="form-control" placeholder="Search on {{block.oggetto_ricerca}}"
            [formControl]="searchControl">
        <div class="input-group-append">
            <a [routerLink]="navigationService.splitUrlRouterLink(actualRoute).path" [queryParams]="navigationService.splitUrlRouterLink(actualRoute).queryParams">
                <button [queryParams]="{search: searchControl.value}" class="btn btn-outline-primary" type="button"><i
                        class="fas fa-search"></i></button>
            </a>
        </div>
    </div>
    <ng-container *ngIf="items && items.length;else noContent">
        <div *ngFor="let item of items" class="row mb-3">
            <div *ngIf="item.field_immagine_cover" class="col-xl-3 col-12">
                <img loading="lazy" class="news-image" [src]="domainWebsite + item.field_immagine_cover" alt="image description">
            </div>
            <div class="ms-3" class="col-xl-9 col-12">
                <a [routerLink]="navigationService.splitUrlRouterLink(item.field_link).path" [queryParams]="navigationService.splitUrlRouterLink(item.field_link).queryParams">
                    <h4 *ngIf="item.Titolo" [innerHTML]="item.Titolo"></h4>
                </a>
                <div *ngIf="item.Testo_news" [innerHTML]="item.Testo_news"></div>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center">
            <button *ngIf="items.length < totalItems" class="btn btn-primary" (click)="showMore()"
                [disabled]="waitItems">
                Show more <i *ngIf="waitItems" class="fas fa-spin fa-circle-notch ms-3"></i>
            </button>
        </div>
        <div class="d-flex flex-row justify-content-center">
            <p>{{items.length}} {{"BLOCK.COMPLETE_RESULTS.ELEMENTS_OF" | translate}} {{totalItems}}</p>
        </div>
    </ng-container>
    <ng-template #noContent>
        <div class="d-flex justify-content-center align-items-center">
            <p>{{"BLOCK.COMPLETE_RESULTS.NO_RESULTS"}}</p>
        </div>
    </ng-template>
</ng-container>